import { createSelector } from '@reduxjs/toolkit'
import { isString } from 'common/helpers'
import type { ProjectId } from 'common/types'

import type { ProjectTableView } from '../../types'
import { selectAllCompanies } from '../companies'
import { selectAllFields } from '../fields'
import type { RootState } from '../store'
import { selectPreferredName } from '../user'
import { prepareProjectList } from './helpers'
import { projectsAdapter } from './projectsSlice'

const selectors = projectsAdapter.getSelectors<RootState>(state => state.projects)
export const {
  selectAll: selectAllProjectsRaw,
  selectById: selectProjectById,
  selectTotal: selectProjectCount,
} = selectors
const { selectEntities, selectIds: selectProjectsIdsRaw } = selectors

export const selectProjectsIds = createSelector([selectProjectsIdsRaw], (ids): ProjectId[] =>
  ids.filter(isString),
)

export const selectProjectsIdsFreeOfSize = createSelector(
  [selectAllProjectsRaw],
  (projects): ProjectId[] =>
    projects
      .filter(project => Number.isNaN(+project.size) && isString(project.id))
      .map(({ id }) => id),
)

const selectAllProjects = createSelector(
  [selectEntities, selectPreferredName, (state, query: string) => query],
  (projects, user, query) => {
    return prepareProjectList(projects, user, query)
  },
)
export const selectProjectStatus = (state: RootState) => state.projects.status
export const selectProjectError = (state: RootState) => state.projects.error
export const selectProjectsTableView = createSelector(
  [selectAllProjects, selectAllCompanies, selectAllFields],
  (allProjects, allCompanies, allFields): ProjectTableView[] => {
    return allProjects.map(project => {
      return {
        ...project,
        companyName: allCompanies.find(company => company.id === project.companyId)?.name,
        fieldName: allFields.find(field => field.id === project.fieldId)?.name,
        icons: true,
      }
    })
  },
)
